// This code does feature detection for the passive option of addEventListener
let passiveSupported = false;

try {
  const options = Object.defineProperty({}, 'passive', {
    // eslint-disable-next-line
    get: function () {
      // eslint-disable-next-line
      passiveSupported = true;
    },
  });

  window.addEventListener('test', null, options);
} catch (err) {
  // don't do anything
}

export default passiveSupported;
